export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: theme.palette.grey[800],
          padding: theme.spacing(0.75, 1.5),
          fontSize: '0.875rem',
          boxShadow: theme.shadows[4],
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}

